import React from 'react';
import { Image as ImageInterface } from '../../interfaces/image';
import { Text as TextInterface } from '../../interfaces/text';
import RichTextRenderer from '../richTextRenderer';
import Image from '../Image';

interface PredefinedSectionInterface {
  id: string;
  heroSection: boolean;
  orientation: string;
  sectionText: TextInterface;
  sectionImage: ImageInterface;
}

function PredefinedSection({
  id,
  heroSection,
  orientation,
  sectionText,
  sectionImage,
}: PredefinedSectionInterface) {
  return (
    <section
      className={`cl-section ${
        heroSection
          ? ` cl-section--bg-top-00 cl-section--bg-middle-neutral cl-section--bg-bottom-07`
          : ''
      }`}
      key={id}
    >
      <div className='cl-section__bg'></div>
      <div className='cl-container'>
        <div className='cl-row cl-row--align-center'>
          <div
            className={`cl-col col-span-4 lg:col-span-6  ${
              orientation === 'Text First' ? 'order-1' : 'order-2'
            } `}
          >
            <RichTextRenderer
              text={sectionText}
              fontSize={heroSection ? 'lg' : ''}
              desktopFontSize={heroSection ? 'lg' : ''}
              textStyle='Default'
            />
          </div>
          <div
            className={`cl-col col-span-4 lg:col-span-6  ${
              orientation === 'Image First' ? 'order-1' : 'order-2'
            } `}
          >
            <Image data={sectionImage} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default PredefinedSection;
